export const concatenateTitle = title =>
  [title.text, title.highlight, title.offersHighlight, title.suffix]
    .filter(field => field)
    .join(' ')
    .trim();
